module.exports = __webpack_public_path__ + "static/media/2.a65bf61f.JPG";